// extracted by mini-css-extract-plugin
module.exports = {"productLineItem":"Yqc0G4"};